export const checkIsNumericGoalValue = R.both(
    R.pathSatisfies(R.is(Number), ['goalInfo', 'value']),
    R.pathEq(['goalInfo', 'type'], 0)
);

export const getGoalRangeActive = R.pathOr(false, ['goalRange', 'active']);
export const getGoalRangeValues = R.pathOr([], ['goalRange', 'values']);
